const lsEntryMap = {
  authentication: 'authentication',
  cart: 'cart',
  environment: 'environment',
  grids: 'grids',
  session: 'session',
}

export default lsEntryMap
